export const getUploadedFileBase64 = (file) => {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
        reader.onerror = () => {
            reader.abort();
            reject(new Error('Error parsing file'));
        };

        // eslint-disable-next-line func-names
        reader.onload = function () {
            //This will result in an array that will be recognized by C#.NET WebApi as a byte[]
            const bytes = Array.from(new Uint8Array(this.result));

            //if you want the base64encoded file you would use the below line:
            const base64StringFile = btoa(bytes.map(item => String.fromCharCode(item)).join(''));

            //Resolve the promise with your custom file structure
            resolve({
                bytes,
                base64StringFile,
                fileName: file.name,
                fileType: file.type.split('/')[1],
            });
        };
        reader.readAsArrayBuffer(file);
    });
};

export const inputFilterForImageFile = (newFile) => {
    if (newFile) {
        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
            //  this.communityCommonConstant.post.ErrorMessage = 'Your choice is not a picture';
            return;
        }
        newFile.url = '';
        const URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
            newFile.url = URL.createObjectURL(newFile.file);
        }
    }
};

export const createFormDataForSelectedFiles = (files) => {
    const formData = new FormData();
    if (files && files.length) {
        files.forEach((item, index) => {
            formData.append(`file${index}`, item.file);
        });
    }
    return formData;
};

export const prepareTempImagesForSave = (tempFiles) => {
    if (tempFiles && tempFiles.length) {
        return tempFiles.map((file) => {
            return {
                pendingBlobStoragePath: file.uploadedFilePath,
                name: file.fileName,
            };
        });
    }
    return [];
};

export const getFilteredListForUpdatedImages = (listOfImages) => {
    return {
        previouslySavedData: listOfImages.filter(image => !image.hasOwnProperty('file')),
        newlyAddedData: listOfImages.filter(image => image.hasOwnProperty('file')),
    };
};
